import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export interface PrescriptionListItem {
  id: string
  prescription_number: number
  patient_id: string
  medication_id: string
  treatment_id: string | null
  veterinarian_id: string | null
  dosage: string
  frequency: string
  route: string
  duration: string
  quantity_dispensed: number
  total_refills: number
  remaining_refills: number
  start_date: string
  end_date: string | null
  status: string
  created_at: string
  // Joined fields
  patient_name: string
  medication_name: string
  veterinarian_name: string | null
}

interface PrescriptionListState {
  prescriptions: PrescriptionListItem[]
  loading: boolean
  error: string | null
}

const initialState: PrescriptionListState = {
  prescriptions: [],
  loading: false,
  error: null,
}

export const fetchPrescriptionList = createAsyncThunk('prescriptionList/fetchAll', async () => {
  const res = await fetch('/.netlify/functions/prescriptions')
  if (!res.ok) throw new Error('Failed to fetch prescriptions')
  return res.json() as Promise<PrescriptionListItem[]>
})

const prescriptionListSlice = createSlice({
  name: 'prescriptionList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrescriptionList.pending, (state) => {
        if (state.prescriptions.length === 0) state.loading = true
      })
      .addCase(fetchPrescriptionList.fulfilled, (state, action) => {
        state.prescriptions = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(fetchPrescriptionList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to load'
      })
  },
})

export default prescriptionListSlice.reducer
